<template>
  <div class="load">
    <p class="shadow"></p>
    <div class="loadTxt">
      <div class="loadLeft">
        <span class="loadCircle"></span>
        <span class="loadImg"></span>
      </div>
      <span class="loadText">{{loadingtext}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loadingtext: {
      type: String,
      required: false
    }
  },
  created: function() {
    var that = this;
    that.loadingtext = that.loadingtext ? that.loadingtext : '加载中...';
  }
}
</script>
<style scoped>
.load {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}

.shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: rgba(0, 0, 0, 0);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.loadTxt {
  height: 43px;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 2;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  padding: 0 16px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: rgba(0, 0, 0, .65);
  border-radius: 4px;
  white-space: nowrap;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.loadLeft {
  width: 20px;
  height: 20px;
  margin: 0 7px 0 0;
  position: relative;
}

.loadCircle {
  display: block;
  width: 20px;
  height: 20px;
  background: url("//static.daojia.com/fe/h5/activity/static/new/images/loading.png") no-repeat;
  background-size: 20px 20px;
  -webkit-animation: Rotater 1s linear 0s infinite;
  animation: Rotater 1s linear 0s infinite;
}

.loadImg {
  display: block;
  width: 8px;
  height: 8px;
  background: url("//images.daojia.com/jz/pic/921fb10a85137ef4e18e26d1a9cba6d9.png") no-repeat;
  background-size: 8px 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.loadText {
  display: block;
  margin: 1px 0 0;
}

@-webkit-keyframes Rotater {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(270deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes Rotater {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(270deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// Loading.vue?2537bf9a